import { Dialog, DialogContent, DialogActions, Alert } from "@mui/material";
import { CustomDialogTitle } from "../../../Modules/Common/Custom/CustomDialogTitle";
import { MDBox } from "./MDBox";
import { MDButton } from "./MDButton";
import { MDTypography } from "./MDTypography";
import { DataTable } from "./DataTable/DataTable";
import { MersetaDelete } from "../../Model/Dto/WSP/MerSetaDelete";
import { WarningDialogTableMapper } from "./WarningDialogTableMapper";
import { useState } from "react";

interface IProps {
    showDialog: boolean;
    heading: string;
    message: string;
    tableData: MersetaDelete[];
    itemCount: number;
    showing: number;
    handleAccept: () => void;
    handleLinkClick: (trainingType: string, associationType: string, id: number) => void;
}

export const WarningDialogWithTable = (props: IProps) => {
    const [entriesPerPage] = useState<number>(25);
    const [pageNumber] = useState<number>(1);

    const warningDialogTableData = WarningDialogTableMapper(props.tableData, props.handleLinkClick);

    return (
        <Dialog open={props.showDialog} onClose={props.handleAccept} aria-labelledby="form-dialog-title" maxWidth='md'>
            <CustomDialogTitle id="customized-dialog-title" onClose={props.handleAccept}>
                {props.heading}
            </CustomDialogTitle>
            <DialogContent>
                <MDBox>
                    <MDTypography variant="button" fontWeight='regular' fontSize="0.9em">
                        <Alert severity='warning'>
                            {props.message}
                        </Alert>
                    </MDTypography>
                    <DataTable
                        table={warningDialogTableData}
                        entriesPerPage={{ defaultValue: entriesPerPage }}
                        pageNumber={pageNumber}
                        filteredItemsCount={props.itemCount}
                        totalItemsCount={props.itemCount}
                        showTotalEntries={false}
                        canSearch={false}
                        manualSorting={false}
                        showEntriesPerPage={false}
                        showBottomMargin={false}
                    />
                    <MDTypography paddingTop="13px" fontWeight='regular' fontSize="1em" color="black">
                        {`Showing ${props.showing} of ${props.itemCount} Associations`}
                    </MDTypography>
                </MDBox>
            </DialogContent>
            <DialogActions>
                <MDBox display="flex" justifyContent="space-between">
                    <MDButton color="primary" variant="contained" onClick={props.handleAccept}>
                        Done
                    </MDButton>
                </MDBox>
            </DialogActions>
        </Dialog>
    )
}